import { UserQuery, useMeQuery, useUserQuery } from '../../generated/graphql';

import { DocumentsList } from '../../components';
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { formatTimestamp } from '../../utils';
import { getTeacherValue } from '../../helpers/getTeacherValue';

interface ModerationUserScreenParams {
    id: string;
}

type ModerationUserScreenProps = RouteComponentProps<ModerationUserScreenParams>;

type Documents = NonNullable<UserQuery['user']>['documents'];

export const ModerationUserScreen: React.FC<ModerationUserScreenProps> = ({ match }) => {
    const id = match.params.id;
    const { data } = useUserQuery({ variables: { id } });
    const user = data?.user;
    const me = useMeQuery();

    const status0: Documents = [];
    const status1: Documents = [];
    const status3: Documents = [];

    if (!me.data?.me?.id) {
        return null;
    }

    if (!me.data?.me?.admin && !me.data?.me?.moderator && me.data?.me?.id !== id) {
        return null;
    }

    data?.user?.documents?.forEach((document) => {
        if (document.status === 0) {
            status0.push(document);
        }
        if (document.status === 1) {
            status1.push(document);
        }
        if (document.status === 3) {
            status3.push(document);
        }
    });

    const totalValue = status1.reduce((acum, document) => getTeacherValue(document.documentType?.values) + acum, 0);

    return (
        <div>
            <div>Ім'я: {user?.name}</div>
            <div>Email: {user?.email}</div>
            <div>Підрозділ: {user?.group.name}</div>
            <div>Дата реєстрації: {formatTimestamp(user?.createdAt)}</div>
            <br />
            <div>Загальна кількість балів: {totalValue}</div>
            <div>Кількість неопрацьованих документів: {status0.length}</div>
            <div>Кількість підтверджених документів: {status1.length}</div>
            <div>Кількість відхилених документів: {status3.length}</div>
            <br />
            <div>Документи: </div>
            <DocumentsList documents={user?.documents} moderation />
        </div>
    );
};
